import { Platform } from "react-native";
import { toogleLoading } from "../../store/slices/PolicySlice";
import { useAppDispatch } from "../../store/Store";
import Constants from "../../utilities/Constants";
import { getUserIdFromToken } from "../../utilities/HelperFunctions";
import Storage from "../../utilities/storage/StorageFunctions";
import Config from "react-native-config";
import {
  deleteUserAccount,
  excludeUserFromClientGroup,
  introspectionAPI,
} from "../user";
import { messages } from "../../../src/resources/strings";
import {
  clearSessionAndLogout,
  handleInvalidTokenCase,
} from "../../utilities/AuthHelper";
import { useNavigation } from "@react-navigation/native";
import { useAuth0 } from "@auth0/auth0-react";

const deleteAccountHandler = (setErrorMessage: (data: string) => void) => {
  const navigation = useNavigation();
  const { logout } = useAuth0();
  const dispatch = useAppDispatch();

  const setLoading = (loading: boolean) => {
    dispatch(toogleLoading(loading));
  };

  const handleInvalidTokenCase = () => {
    clearSessionAndLogout(navigation, logout);
  };

  const deleteAccountAction = async () => {
    setLoading(true);
    const tokenLS = await Storage.getData(
      Constants.LocalStoreConstant.ACCESS_TOKEN
    );
    const userId = getUserIdFromToken(tokenLS);
    const clientId =
      Platform.OS == "web"
        ? process.env.REACT_APP_EXZEO_ID_CLIENT_ID
        : Config.REACT_APP_EXZEO_ID_CLIENT_ID;

    // Delete user from Nexus
    const notificationDeleteResponse = await deleteUserAccount();
    // Revoke access of ph app client
    const response = await excludeUserFromClientGroup(userId, clientId ?? "");

    if (
      response.errorCode == messages.error.noError &&
      notificationDeleteResponse.errorCode == messages.error.noError
    ) {
      await Storage.storeData(Constants.LocalStoreConstant.DELETE_ACCOUNT, "1");
      handleInvalidTokenCase();
    } else {
      await Storage.storeData(Constants.LocalStoreConstant.DELETE_ACCOUNT, "0");
      setErrorMessage(messages.error.somthingWrong);
    }
    setLoading(false);
  };

  //API :: call Introspection and ForgotPassword Api ::
  const callIntrospectionAndDeleteApi = async () => {
    setLoading(true);

    const introspectionResponse = await introspectionAPI();
    if (introspectionResponse.response) {
      deleteAccountAction();
    } else {
      setLoading(false);
      setErrorMessage(messages.error.sessionExpired);
    }
  };

  return { deleteUser: callIntrospectionAndDeleteApi };
};

export default deleteAccountHandler;
